<nz-modal
  [(nzVisible)]="isVisibleGenerateReportModal"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelGenerateReportModal()"
  nzClosable="false"
>
  <ng-template #modalTitle>
    <div class="flex justify-between items-center my-4">
      <h4>{{headerName}}</h4>
      <button *appHasAnyPrivilege="''" nz-button nzType="primary" [disabled]="generateLoading" (click)="Actions('preview')">Preview</button>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="my-4">
      <p class="success-tag" *ngIf="!generateLoading">Report Generated Successfully!</p>
      <p class="loading-tag" *ngIf="generateLoading">Report Generating ....</p>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="flex justify-between items-center my-4">
      <button nz-button nzType="default" class="cancel-btn" (click)="handleCancelGenerateReportModal()">Cancel</button>
      <div class="flex gap-2">
        <button *appHasAnyPrivilege="''" nz-button nzType="default" class="outline-button" [disabled]="generateLoading" (click)="Actions('download')">Download</button>
        <button *appHasAnyPrivilege="''" nz-button nzType="default" class="outline-button" [disabled]="generateLoading" (click)="Actions('email')">Send</button>
        <button *appHasAnyPrivilege="''" nz-button nzType="default" class="outline-button" [disabled]="generateLoading" (click)="Actions('print')">Print</button>
      </div>
    </div>
  </ng-template>
</nz-modal>
